import { SUPPLY_DEMAND, SUPPLY_DEMAND_LOADING } from '../../actions/industry'
import * as h2Api from '../../h2Api'

const initialState = {
  inDemand: [
    '13-2011.00',
    '11-9041.00',
    '47-2021.00',
    '49-3031.00',
    '47-2031.00',
    '47-2051.00',
    '35-1011.00',
    '17-2051.00',
    '19-3031.00',
    '11-3021.00',
    '15-1143.00',
    '15-1199.00',
    '15-1121.00',
    '15-1151.00',
    '47-2061.00',
    '13-1051.00',
    '51-9021.00',
    '47-2081.00',
    '47-5021.00',
    '17-3023.00',
    '17-2071.00',
    '47-2111.00',
    '17-3029.00',
    '17-2199.00',
    '17-2081.00',
    '19-2041.00',
    '53-7032.00',
    '51-1011.00',
    '35-1012.00',
    '49-1011.00',
    '43-1011.00',
    '53-1031.00',
    '11-9051.00',
    '11-9071.00',
    '39-1011.00',
    '11-1021.00',
    '49-9021.00',
    '53-3032.00',
    '51-9198.00',
    '47-5081.00',
    '53-7051.00',
    '49-9041.00',
    '11-3051.00',
    '15-1122.00',
    '51-9061.00',
    '53-7062.00',
    '29-2061.00',
    '13-1081.00',
    '51-4041.00',
    '49-9071.00',
    '49-9043.00',
    '13-1111.00',
    '11-9199.00',
    '13-1161.00',
    '17-2131.00',
    '17-3027.00',
    '17-2141.00',
    '19-1042.00',
    '29-2012.00',
    '11-9111.00',
    '21-1023.00',
    '21-1014.00',
    '49-9044.00',
    '47-5042.00',
    '17-2151.00',
    '51-9023.00',
    '15-1142.00',
    '29-1171.00',
    '29-9011.00',
    '29-9012.00',
    '47-2073.00',
    '47-2141.00',
    '29-1051.00',
    '29-1071.00',
    '29-1069.00',
    '47-2152.00',
    '51-9199.00',
    '13-1023.00',
    '29-1141.00',
    '47-2171.00',
    '47-2181.00',
    '41-4012.00',
    '41-4011.00',
    '47-2211.00',
    '15-1133.00',
    '15-1132.00',
    '47-2221.00',
    '17-1022.00',
    '51-8031.00',
    '15-1134.00',
    '51-4121.00'
  ],
  crosswalk: [],
  supply: [],
  demand: [],
  occupationsInCluster: [],
  flags: {},
  loading: false,
  clusters: [],
  jobZones: []
}
const reducers = (state = initialState, action) => {
  switch (action.type) {
    case SUPPLY_DEMAND:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        const p = action.restCall.result

        return {
          ...state,
          loading: false,
          demand: p.demand,
          occupationsInCluster: p.occupationsInCluster,
          supply: p.supply,
          crosswalk: p.crosswalk,
          flags: p.flags,
          clusters: p.clusters,
          jobZones: p.jobZones
        }
      }

      if (action.restCall.status === h2Api.REST_CALL_STATUS.ERROR) {
        return {
          ...state,
          loading: false
        }
      }

      return state

    case SUPPLY_DEMAND_LOADING:
      return {
        ...state,
        loading: true
      }

    default:
      return state
  }
}

export default reducers
